module.exports = __webpack_public_path__ + "img/helpcenter.af.ee335d17.svg";